import { IStat, IStats } from "../../types";

// cleanup negative stat values and values bigger than stat's max
export const clamp = (stat: IStat) => {
  stat.max = Math.round(stat.max);
  stat.max = Math.max(0, stat.max);
  stat.value = Math.round(stat.value);
  stat.value = Math.max(0, stat.value);
  stat.value = Math.min(stat.value, stat.max);
};

// refresh stat value to its max (max acts as a cache of sorts)
export const refresh = (stat: IStat) => {
  clamp(stat);
  stat.value = stat.max;
};

// for most stats, except hp & mp, max is used to cache the regular stats' value
export const refreshAll = (stats: IStats) => {
  Object.entries(stats).forEach(([key, stat]) => {
    clamp(stat);
    if (key !== "hp" && key !== "hp") stat.value = stat.max;
  });
};
